import Utils from "./utils.class";
import MarketoPlugin from "./MarketoPlugin.class";
const { jQuery: $ } = window;

export default class ZoomInfo extends MarketoPlugin {
    #enabled;
    #developerMode;
    #lookupField;
    #formID;
    #filters = {};

    constructor(lookupField, formID, enabled, sandbox, filters) {
        super();

        Utils.log("Registered: Zoominfo");

        this.#enabled = enabled;
        this.#developerMode = sandbox;
        this.#lookupField = lookupField;
        this.#formID = formID;
        this.#filters = filters;

        $(window).on("kmdg_marketo_dto_loaded", (e, form) => {
            form.getFormElem().find("[name=" + this.#lookupField + "]").trigger("change");
        });
    }

    marketoIntegration() {
        const self = this;

        $.getScript(location.protocol + "//" + location.host + "/wp-content/themes/kmdg/dist/js/FormsPlus.min.js", () => {
            // Zoominfo integration - the above script adds extra info to marketo tags that is useful for styling with or without zoominfo.
            Utils.log("[ZI] FormsPlus loaded.");

            if (self.#enabled) {
                Utils.log("[ZI] Init zoominfo...");

                const baseUrl = "https://ws.zoominfo.com/form-complete/";
                const matchPath = self.#developerMode ? "match-dev" : "match";

                $.getJSON(baseUrl + 'getMapping?formId=' + self.#formID, (data) => {
                    Utils.log("[ZI] Got field mappings...");

                    if (data) {
                        MktoForms2.whenReady((form) => {
                            let $el = form.getFormElem();

                            $el.addClass("zi-managed--form");

                            for (let i in data.inputs) {
                                let name = data.inputs[i].nameAttr;

                                if (name !== this.#lookupField) {

                                    $el.find(".mktoFormRow[data-wrapper-for=" + name + "]")
                                        .addClass("zi-managed--input")
                                        .addClass("zi-managed--hidden")
                                        .attr("data-zi-mapped-field", data.inputs[i].mappedField)
                                        .on("change", function () {
                                            $(this).not(".zi-managed--hidden").addClass("zi-managed--locked");
                                        });
                                }
                            }

                            $el.find("[name=" + this.#lookupField + "]").on("change blur", Utils.debounce(250, false, function () {
                                const email = $(this).val();
                                const $form = $(this).parents('form');

                                if (email.length <= 5 && !email.includes("@")) {
                                    return;
                                }

                                Utils.log("[ZI] Looking Up Data...");

                                $.getJSON(baseUrl + matchPath + "?formId=" + self.#formID + "&email=" + email, (results) => {

                                    if (results.form) {
                                        $form.find(".mktoFormRow.zi-managed--input").not(".zi-managed--locked").each(function (i, el) {
                                            let found = false;

                                            for (let field in results.form) {
                                                let mapping = $(el).attr('data-zi-mapped-field');

                                                if (field === mapping) {
                                                    let val = results.form[field];

                                                    if (self.#filters[field]) {
                                                        Utils.log("[ZI] Filtering field [" + field + "] with value: ", val);
                                                        val = self.#filters[field].call(this, val);
                                                    }

                                                    Utils.log("[ZI] Autofilling field [" + field + "] with value: ", val);
                                                    $(el).addClass("zi-managed--hidden").find("input, select").val(val);
                                                    found = true;
                                                    break;
                                                }
                                            }

                                            if (!found) {
                                                $(el).removeClass("zi-managed--hidden").find("input").val("");
                                            }
                                        });
                                    }
                                }).fail(function () {
                                    Utils.log("[ZI] Data lookup failed.");

                                    $form.find(".mktoFormRow.zi-managed--hidden").each(function (i, el) {
                                        $(el).removeClass("zi-managed--hidden").find("input").val("");
                                    });
                                });
                            }));
                        });
                    }
                }).fail(function () {
                    Utils.log("Failed to connect to ZoomInfo.");
                });
            }
        });
    }
}